var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-avatar", style: { width: !_vm.noName ? "3em" : "" } },
    [
      _c(
        "div",
        {
          class: { "comm-avatar": true, "comm-avatar-name": !_vm.avatar },
          style: _vm.avaStyle,
        },
        [
          !_vm.avatar
            ? _c("span", [_vm._v(_vm._s(_vm.userName))])
            : _c("el-image", {
                staticClass: "avatar-image",
                staticStyle: { height: "100%", width: "100%" },
                attrs: { src: _vm.avatar, lazy: "", fit: "cover" },
              }),
        ],
        1
      ),
      !_vm.noName
        ? _c("div", { staticClass: "userName" }, [_vm._v(_vm._s(_vm.name))])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }